import { useState } from "react";
import { toastService } from "@services/ToastService";
import { donorService } from "@services/DonorService";
import { DonorPayload } from "@shared/interfaces/ProgramFiles";

export const useDonor = () => {
  const [loading, setLoading] = useState(false);

  const saveDonor = async (
    payload: DonorPayload,
    options?: {
      donorId?: string | number;
    }
  ) => {
    setLoading(true);
    try {
      const response = options?.donorId
        ? null // Donor update not supported
        : await donorService.createDonor(payload);

      toastService.success(
        `Donor ${options?.donorId ? "updated" : "created"} successfully`
      );

      return response;
    } catch (error) {
      toastService.error("Failed to save donor");
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const getAllDonors = async () => {
    setLoading(true);
    try {
      const response = await donorService.getAllDonors();
      return response || [];
    } catch (error) {
      console.error("Failed to fetch donors");
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const getDonorById = async (donorId: string | number) => {
    try {
      return await donorService.getDonorById(donorId);
    } catch (error) {
      console.error("Failed to fetch donor");
      throw error;
    }
  };

  const deleteDonor = async (donorId: string | number) => {
    setLoading(true);
    try {
      await donorService.deleteDonor(donorId);
      toastService.success("Donor deleted");
    } catch (error) {
      toastService.error("Failed to delete donor");
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const searchDonors = async (searchQuery: string) => {
    try {
      const response = await donorService.searchDonorsByName(searchQuery);
      return response || [];
    } catch (error) {
      console.error("Failed to search donors");
      throw error;
    }
  };

  return {
    loading,
    saveDonor,
    getAllDonors,
    getDonorById,
    deleteDonor,
    searchDonors,
  };
};
